import React from 'react';
import { connect } from 'react-redux';
import { Map, Marker, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import 'react-leaflet-markercluster/dist/styles.min.css';
import { getLocationByCompany } from '../../../actions/EpikBoxes';
import './EpikBoxesMap.css';
import CustomMarker from './CustomMarker';

// const position = [3343.0973, -11751.0910];
const position = [37.0902, -95.7129];

const EpikBoxesMap = props => {
  const { selectLocation, epikBoxLocations } = props;

  return (
    <Map
      boundsOptions={{
        maxZoom: 10,
      }}
      center={position}
      zoom={5}
      className="map-box"
      maxZoom={18}
      zoomControl
    >
      <TileLayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" />
      {epikBoxLocations.map((loc, idx) => {
        if (loc?.location?.geoJson?.coordinates.length === 2 || false) {
          return (
            <Marker
              key={idx}
              icon={L.divIcon({
                className: 'custom icon',
                html: ReactDOMServer.renderToString(
                  <CustomMarker count={loc.boxes.length} border={loc.color} />,
                ),
              })}
              onClick={async () => {
                selectLocation(loc);
              }}
              position={{
                lat: loc?.location?.geoJson?.coordinates[1],
                lng: loc?.location?.geoJson?.coordinates[0],
              }}
            />
          );
        }
      })}
    </Map>
  );
};

const mapStateToProps = state => {
  return {
    setCompanyFilter: state.UIState.epikBoxes.companyFilter,
    epikBoxLocations: state.AppState.epikBoxLocations,
  };
};
const mapDispatchToProps = dispatch => ({
  getLocationByCompany: (token, cid) => dispatch(getLocationByCompany(token, cid)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EpikBoxesMap);
